import Icon from '../components/Icon.vue'

Icon.register({
  'sad-cry': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248 0 90-48.2 168.7-120 212.1v-180.1c0-8.8-7.2-16-16-16s-16 7.2-16 16v196.7c-29.5 12.4-62 19.3-96 19.3s-66.5-6.9-96-19.3v-196.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v180.1c-71.8-43.4-120-122-120-212.1 0-137 111-248 248-248zM182.5 224.5l9.7 8.5c2.5 2.3 7.9 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.9-42.1-25.7 0-55.9 16.9-59.9 42.1-0.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM248 416c26.5 0 48-28.7 48-64s-21.5-64-48-64-48 28.7-48 64 21.5 64 48 64zM397.8 234.5c4.4-2.4 6.8-7.4 6.2-12.3-4-25.2-34.2-42.1-59.9-42.1-25.7 0-55.9 16.9-59.9 42.1-0.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.7 13.7-1.6l9.6-8.6c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.7 13.7 1.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sad-cry.js
// module id = 1858
// module chunks = 0